import logoUrl from '../assets/stromo_logo.svg';

interface LogoProps {
  /** "sidebar" für die kompakte Variante, "full" für Login/Headers */
  variant?: 'sidebar' | 'full';
}

export function Logo({ variant = 'sidebar' }: LogoProps) {
  if (variant === 'sidebar') {
    return (
      <div className="logo-area">
        <svg
          width="32"
          height="32"
          viewBox="0 0 100 100"
          xmlns="http://www.w3.org/2000/svg"
          aria-hidden="true"
        >
          <rect x="0" y="0" width="100" height="100" rx="22" fill="#185FA5" />
          <rect x="5" y="5" width="90" height="90" rx="18" fill="#1870c4" />
          <polygon
            points="62,8 36,46 54,46 38,92 74,50 54,50"
            fill="#ffffff"
            opacity="0.95"
          />
          <polygon
            points="62,8 60,13 54,50 56,50 38,92 42,92 60,54 42,54 64,14"
            fill="#facc15"
            opacity="0.9"
          />
        </svg>
        <div className="logo-wordmark">Stromo</div>
        <div className="logo-sub">Projektverwaltung</div>
      </div>
    );
  }
  return <img src={logoUrl} alt="Stromo" />;
}
